<template lang='pug'>
  .building-structure#building-structure
    button#building-structure-filter
      span {{ $t('competitors_filters.building_structure') }}
      span#checked-building-structure {{ formattedFilter(buildingStructureList, value) }}
    b-popover(ref="filter_popover" target='building-structure-filter' triggers='click blur' placement='bottomright' container='building-structure')
      .building-structure-wrapper
        ul.building-structure-list
          li(v-for='structure in buildingStructureList')
            input.building-structure-checkbox(
            type='checkbox'
            v-model='value'
            :value='structure.item_value'
            @change='changedFilterValue(value)'
          )
            span {{ structure.title }}
      button.view-search-results(@click="viewSearchResults(value)") {{ $t('competitors_filters.view_search_results') }}
</template>

<script>
  import formatFilter from '@/mixins/formatted-filter'
  import applyFilter from '@/mixins/apply-filter'

  export default {
    mixins: [
      formatFilter,
      applyFilter
    ],

    props: {
      buildingStructure: {
        type: Array,
        default: () => ([])
      }
    },

    data() {
      return {
        value: this.buildingStructure,
      }
    },

    computed: {
      buildingStructureList() {
        return [
          {
            item_value: 'src',
            title: this.$t('building_structure.src'),
          },
          {
            item_value: 'rc',
            title: this.$t('building_structure.rc'),
          },
          {
            item_value: 's',
            title: this.$t('building_structure.s'),
          },
          {
            item_value: 'w',
            title: this.$t('building_structure.w'),
          },
          {
            item_value: 'others',
            title: this.$t('building_structure.others'),
          }
        ]
      }
    }
  }
</script>

<style lang='scss' scoped>
  @import '@/assets/css/mixins/competitors/filter.scss';
  
  .building-structure {
    #building-structure-filter {
      @include button-item-filter;

      #checked-building-structure {
        @include span-checked-item;
      }
    }
  }

  .building-structure-wrapper {
    @include item-filter-wrapper;

    .building-structure-list {
      @include item-filter-ul;

      .building-structure-checkbox {
        @include item-checkbox;
      }
    }
  }
  
  #building-structure {
    ::v-deep.popover {
      min-width: 200px !important;
    }
  }

  .view-search-results {
    @include view-search-results;
  }
</style>
